import React, { useEffect, useRef, useState } from "react";
import "./ContactDetails.css";
import imageavatar from "../../../assets/images/Ellipse 1.png";
import FrameComponent1 from "../FrameCompoenent/FrameComponent";
import watch from "../../../assets/images/schedule.svg";
import {
  FaRegStar,
  FaStar,
  FaStarHalfAlt,
  FaChevronDown,
  FaChevronUp,
} from "react-icons/fa";
import CustomAudioPlayer from "../CustomAudioPlayer/CustomAudioPlayer";
import { useSelector } from "react-redux";
import UIConfig from "../../constants/UIConfig";
import { FaEdit, FaUser, FaAlignLeft } from "react-icons/fa";
import CategoryLeadPopup from "../Popups/CategoryLeadPopup";
import { postCategory } from "../../../operations/services/postCategory";
import { notify } from "../../Helper/notification";
import { formatPhoneNumber } from "../../Helper/formatPhoneNumber";
import { useDispatch } from "react-redux";
import { getDetailsPageDataInit } from "../../../redux/slices/operationHomeSlice";
import { capitalize } from "../../Helper/capitalize";
import CallReviewSheetPopup from "../Popups/CallReviewSheetPopup";
import TranscriptPlayer from "./TranscriptPlayer";
import { getCallTranscript } from "../../../operations/services/getCallTranscript";

const ContactDetails = ({
  memberId,
  memberDetails,
  section,
  sectionLength,
  setSection,
  currentSection,
  callId,
  size,
  navigationDisabled = false,
}) => {
  const [src, setSrc] = useState("");
  const [loadingAudio, setLoadingAudio] = useState(false);
  const [errorAudio, setErrorAudio] = useState("");

  // "Listen with transcript" expands the Audio section into the full player +
  // transcript and folds the two detail sections down to their headers — each
  // keeps an arrow, so anything can be reopened at any time. The agent header
  // at the top stays put throughout. The transcript is fetched lazily on first
  // open per call — most visits never open the player, and transcripts run to
  // tens of KB.
  const [playerOpen, setPlayerOpen] = useState(false);
  const [convoOpen, setConvoOpen] = useState(true);
  const [infoOpen, setInfoOpen] = useState(true);
  const [transcriptState, setTranscriptState] = useState({
    status: "idle", // idle | loading | ready | error
    forCallId: null,
    transcript: "",
    mapping: "",
  });

  // Where playback was when the player last closed, so collapsing the
  // transcript doesn't cost the listener their place — reopening resumes
  // there. A ref, not state: it advances ~4×/second and must not re-render.
  const playbackPosRef = useRef(0);
  // Whether the next open should start playing. "Listen with transcript" is
  // an explicit ask to listen, so it does; kept as a ref so a future caller
  // that only wants to browse the transcript can open it silent.
  const playerAutoPlayRef = useRef(true);

  const openPlayer = (autoPlay = true) => {
    playerAutoPlayRef.current = autoPlay;
    setPlayerOpen(true);
    setConvoOpen(false);
    setInfoOpen(false);
  };

  const closePlayer = () => {
    setPlayerOpen(false);
    setConvoOpen(true);
    setInfoOpen(true);
  };

  const [isCategoryLeadOpen, setIsCategoryLeadOpen] = useState(false);
  const [primaryCategoryValue, setPrimaryCategoryValue] = useState("");
  const [secondaryCategoryValues, setSecondaryCategoryValues] = useState([]);

  const [isOpen, setIsOpen] = useState(false);

  const dispatch = useDispatch();
  const loginData = useSelector((state) => state.login.login.data);
  const userRole = loginData?.data[0]?.Role;

  const canEditCategoryLead =
    userRole === "OPS_ADMIN" || userRole === "Operations Manager" || userRole === "Admin";

  const filedata = useSelector((state) => state.operationHome.table.data);
  const mnScoresByCallId = useSelector(
    (state) => state.operationHome.mnScoresByCallId,
  );

  const activeCallId = section?.items?.[0]?.CallId;
  const CallIdFetch = section?.items?.[0] || {};

  console.log(section, "s");

  const matchingCallDetail = memberDetails?.callDetails?.find(
    (call) => call.CallId === activeCallId,
  );

  const fileSection =
    filedata?.find((call) => call.callId === activeCallId) ?? null;

  // console.log(memberDetails)

  // 1. Get the string response safely
  const rawResponse = section?.items?.[1]?.PromptResponse;

  // 2. Parse it and extract the value
  let callerRelationship = "";

  if (rawResponse) {
    try {
      const parsedData = JSON.parse(rawResponse);

      callerRelationship =
        parsedData?.caller_information?.caller_relationship_to_patient;
    } catch (error) {
      console.error("Error parsing PromptResponse JSON:", error);
    }
  }

  useEffect(() => {
    if (!activeCallId) return;
    let objectUrl = null;
    let isMounted = true;

    const fetchWithRetry = async (
      url,
      options = {},
      retries = 3,
      delay = 1000,
    ) => {
      const token = localStorage.getItem("authToken");
      const mergedOptions = {
        ...options,
        headers: {
          "Content-Type": "application/json",
          ...(options.headers || {}),
          ...(token && { Authorization: `Bearer ${token}` }),
        },
      };
      for (let attempt = 1; attempt <= retries; attempt++) {
        try {
          const res = await fetch(url, mergedOptions);
          if (!res.ok)
            throw new Error(`Fetch failed with status ${res.status}`);
          return res;
        } catch (err) {
          if (attempt < retries) {
            await new Promise((resolve) =>
              setTimeout(resolve, delay * Math.pow(2, attempt - 1)),
            );
          } else throw err;
        }
      }
    };

    const fetchSrc = async () => {
      if (!activeCallId) return;
      setLoadingAudio(true);
      setErrorAudio("");
      try {
        const activeBlobUrl =
          fileSection?.blobUrl || matchingCallDetail?.CallId || null;
        if (activeBlobUrl) {
          const secureApiUrl = `${process.env.REACT_APP_GET_OPERATION_HOME_API}&secureId=${activeBlobUrl}`;
          const res = await fetchWithRetry(secureApiUrl, {}, 3, 1000);
          const contentType = res.headers.get("content-type") || "";
          if (contentType.includes("application/json")) {
            const data = await res.json();
            if (data?.audioUrl) {
              try {
                const audioRes = await fetchWithRetry(
                  data.audioUrl,
                  {},
                  3,
                  1000,
                );
                const blob = await audioRes.blob();
                objectUrl = URL.createObjectURL(blob);
                if (isMounted) setSrc(objectUrl);
              } catch {
                if (isMounted) setSrc(data.audioUrl);
              }
            } else {
              if (isMounted) setSrc(fileSection?.blobUrl || "");
            }
          } else {
            const blob = await res.blob();
            objectUrl = URL.createObjectURL(blob);
            if (isMounted) setSrc(objectUrl);
          }
        } else if (matchingCallDetail?.blobUrl) {
          if (isMounted) setSrc(matchingCallDetail.blobUrl);
        } else {
          if (isMounted) setSrc("");
        }
      } catch (err) {
        if (isMounted) {
          setErrorAudio("Could not load audio.");
          setSrc(matchingCallDetail?.blobUrl || "");
        }
      } finally {
        if (isMounted) setLoadingAudio(false);
      }
    };

    fetchSrc();
    return () => {
      isMounted = false;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [callId, activeCallId, fileSection?.blobUrl, matchingCallDetail?.blobUrl]);

  // Navigating to another call closes the expanded player — its audio source
  // and transcript both belong to the call that was open — and reopens the
  // detail sections for the new call.
  useEffect(() => {
    setPlayerOpen(false);
    setConvoOpen(true);
    setInfoOpen(true);
    playbackPosRef.current = 0; // a saved position belongs to one call only
  }, [activeCallId]);

  // Fetch the transcript the first time the player opens for this call.
  useEffect(() => {
    if (!playerOpen || !activeCallId) return undefined;
    if (
      transcriptState.forCallId === activeCallId &&
      transcriptState.status !== "error"
    )
      return undefined;

    let cancelled = false;
    setTranscriptState({
      status: "loading",
      forCallId: activeCallId,
      transcript: "",
      mapping: "",
    });
    (async () => {
      try {
        const data = await getCallTranscript(activeCallId);
        if (cancelled) return;
        setTranscriptState({
          status: "ready",
          forCallId: activeCallId,
          transcript: data?.transcript || "",
          mapping: data?.mapping || "",
        });
      } catch (err) {
        console.error("[ContactDetails] transcript fetch failed:", err);
        if (!cancelled)
          setTranscriptState({
            status: "error",
            forCallId: activeCallId,
            transcript: "",
            mapping: "",
          });
      }
    })();
    return () => {
      cancelled = true;
    };
    // transcriptState is deliberately not a dependency: this effect writes it,
    // and reacting to that write would loop.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [playerOpen, activeCallId]);

  if (!memberDetails) return <div>No Member Data Available</div>;

  const formatDuration = (d) =>
    d ? `${d.split(":")[0]} mins ${d.split(":")[1]} secs` : "---";
  const convertDate = (d) => {
    if (!d) return "-----";
    const [year, month, day] = d.split("T")[0].split("-");
    return `${day}/${month}/${year}`;
  };

  const agentNames = (() => {
    try {
      const agentJson = section?.items?.[0]?.AgentNameJson;
      if (!agentJson)
        return section?.meetingPerson ? [section.meetingPerson] : [];
      let mappingData =
        typeof agentJson === "string" ? JSON.parse(agentJson) : agentJson;
      return Object.values(mappingData).filter(
        (n) =>
          n &&
          typeof n === "string" &&
          n.trim() !== "" &&
          n.toLowerCase() !== "monte nido",
      );
    } catch {
      return [];
    }
  })();

  const firstCallDetail = section?.items?.[0] || {};
  // console.log(section, "rohit fisrt")

  // ✅ Use API category list (single source)
  const allCategoryOptions =
    memberDetails?.categoryDetails?.map((item) => item.CategoryName) || [];

  const isValidCategory = (v) =>
    v && v.trim() !== "" && v.trim().toLowerCase() !== "null";

  // Match a raw API value to the exact option string so the <select> can display it
  const toExactOption = (val) =>
    allCategoryOptions.find(
      (opt) => opt.trim().toLowerCase() === val?.trim().toLowerCase(),
    ) ||
    val ||
    "";

  // ✅ Primary — same source priority as InsightPanel (callDetails first), then section items
  const primaryCategoryFromAPI =
    [
      matchingCallDetail?.ClientPrimaryCategory,
      matchingCallDetail?.callCategory,
      firstCallDetail?.ClientPrimaryCategory,
      firstCallDetail?.callCategory,
    ]
      .find(isValidCategory)
      ?.trim() || "";

  // ✅ Secondary — same source priority as InsightPanel (callDetails first), then section items
  const rawSecondary = [
    matchingCallDetail?.ClientSecondaryCategory,
    matchingCallDetail?.secondaryCategory,
    firstCallDetail?.ClientSecondaryCategory,
    firstCallDetail?.secondaryCategory,
  ].find(isValidCategory);

  const secondaryCategoriesFromAPI = rawSecondary
    ? rawSecondary
        .split(",")
        .map((i) => i.trim())
        .filter((i) => i && i.toLowerCase() !== "null")
        .map(toExactOption)
    : [];

  const handleCategoryEdit = () => {
    setPrimaryCategoryValue(toExactOption(primaryCategoryFromAPI));
    setSecondaryCategoryValues(secondaryCategoriesFromAPI);
    setIsCategoryLeadOpen(true);
    // setIsOpen(true)
  };

  const handleCategoryLeadSave = async () => {
    try {
      const payload = {
        callCategory: primaryCategoryValue,
        secondaryCategory: secondaryCategoryValues
          .filter((val) => val && val.trim() !== "")
          .join(","),
        callId: CallIdFetch?.CallId,
      };

      // console.log("Payload", payload);

      await postCategory(payload);

      notify.success("Category updated successfully");

      setIsCategoryLeadOpen(false);

      // ✅ Refetch ALL details (Dashboard + all components update)
      setTimeout(() => {
        dispatch(getDetailsPageDataInit(memberId));
      }, 300);
    } catch (error) {
      console.error(error);
      notify.error("Failed to update category");
    }
  };

  const agentDisplayText =
    agentNames.length > 0 ? agentNames.join(", ") : "---";

  const getCallUrgency = (items) => {
    const obj = items?.find((i) => i.L2_promptId === "122");
    if (!obj || obj.PromptResponse === "N/A") return null;
    try {
      const res = JSON.parse(obj.PromptResponse);
      const key = res.follow_up_urgency.toLowerCase();
      if (key.includes("high")) return "High";
      if (key.includes("medium")) return "Medium";
      if (key.includes("low")) return "Low";
    } catch {
      return null;
    }
    return null;
  };

  const urgency = getCallUrgency(section?.items);
  const urgencyStyles = {
    high: { text: "High", bgColor: "#fedad9", color: "#9f3c2b" },
    medium: { text: "Medium", bgColor: "#FFEF9D", color: "#4F4700" },
    low: { text: "Low", bgColor: "#cdfee1", color: "#0c5132" },
  };

  const metadataObj = JSON.parse(firstCallDetail?.Metadata || "{}");
  const callIdMeta = metadataObj?.CallID;
  const mnScore = mnScoresByCallId?.[activeCallId];

  // const renderScoreRating = (score) => {
  //   const scoreVal = parseFloat(score);
  //   if (!isNaN(scoreVal)) {
  //     const scoreOutOf5 = Math.min(5, Math.max(0, scoreVal));
  //     const fullStars = Math.floor(scoreOutOf5);
  //     const halfStars = scoreOutOf5 % 1 >= 0.5 ? 1 : 0;
  //     const emptyStars = Math.max(0, 5 - fullStars - halfStars);

  //     return (
  //       <>
  //         <span className="value">{scoreOutOf5.toFixed(1)}/5</span>
  //         <div className="star-rating">
  //           {[...Array(fullStars)].map((_, i) => (
  //             <FaStar key={`full-${i}`} color="#ffc403" size={14} />
  //           ))}
  //           {halfStars === 1 && <FaStarHalfAlt color="#ffc403" size={14} />}
  //           {[...Array(emptyStars)].map((_, i) => (
  //             <FaRegStar key={`empty-${i}`} color="#ffc403" size={14} />
  //           ))}
  //         </div>
  //       </>
  //     );
  //   }

  //   return <span className="value">---/5</span>;
  // };

  return (
    <div
      className={`contact-details${playerOpen ? " contact-details--player" : ""}`}
    >
      {/* <div className="contact-centre">
        <h3>{UIConfig.detailPanel.Heading}</h3>
        <p>{UIConfig.detailPanel.Text}</p>
      </div> */}

      <div className="user-info">
        <div className="user-avatar-icon">
          <FaUser size={20} color="#f2f2f2" />
        </div>
        <div className="user-details">
          <p>{agentNames.length > 1 ? "Agents" : "Agent"}</p>
          <h3>{agentDisplayText}</h3>
        </div>
      </div>

      <div
        className={`conversation-details${playerOpen ? " conversation-details--fill" : ""}`}
      >
        {/* Collapsible: folds to its header when the player opens, and the
            arrow brings it back at any time. */}
        <button
          type="button"
          className="cd-section-toggle"
          onClick={() => setConvoOpen((v) => !v)}
          aria-expanded={convoOpen}
        >
          <h3>Conversation Details</h3>
          {convoOpen ? (
            <FaChevronUp size={11} className="cd-chevron" />
          ) : (
            <FaChevronDown size={11} className="cd-chevron" />
          )}
        </button>

        {convoOpen && (
          <>
        <div className="conversation-item">
          <span className="label">Category</span>
          <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
            <span className="value-meeting">
              {firstCallDetail?.ClientPrimaryCategory &&
              firstCallDetail.ClientPrimaryCategory.trim().toLowerCase() !==
                "null"
                ? firstCallDetail.ClientPrimaryCategory.trim()
                : firstCallDetail?.callCategory || "---"}
            </span>
            {canEditCategoryLead && (
              <FaEdit
                size={12}
                style={{ cursor: "pointer", color: "#a3aed0" }}
                onClick={handleCategoryEdit}
              />
            )}
          </div>
        </div>

        <div className="conversation-item">
          <span className="label">Client Name</span>
          <span className="value-meeting">
            {memberDetails?.FirstName || "---"}
          </span>
        </div>

        <div className="conversation-item">
          <span className="label">Magic Health ID</span>
          <span className="value-meeting">
            {memberDetails?.CustomerID || "---"}
          </span>
        </div>

        <div className="conversation-item">
          <span className="label">Vonage Call ID </span>
          <span className="vonge-meeting">{callIdMeta || "---"}</span>
        </div>

        <div className="conversation-item">
          <span className="label">
            {firstCallDetail.callType == "inbound" ? "Call From" : "Call To"}
          </span>
          <span className="value-meeting">
            {formatPhoneNumber(memberDetails?.Phone)}
          </span>
        </div>

        <div className="conversation-item">
          <span className="label">Caller Relationship</span>
          <span className="value-meeting">{callerRelationship}</span>
        </div>

        <div className="conversation-item conversation-count-row">
          <span className="red">
            ({size || 0} {size === 1 ? "Conversation" : "Conversations"})
          </span>
        </div>

        <div className="meeting-date-parent">
          <span className="meeting-date2">Meeting Date</span>
          <FrameComponent1
            date={section?.meetingDate}
            sectionLength={sectionLength}
            setSection={setSection}
            currentSection={currentSection}
            disabled={navigationDisabled}
          />
        </div>
          </>
        )}

        {/* The Audio row: label on the left, and on the right the one control
            that swaps between the two views. Closed, it is "Listen with
            transcript" — an explicit ask, so the expanded player opens playing
            from wherever the compact bar stands. Open, it is "Hide transcript",
            which folds back to the compact bar and restores the details. The
            compact bar's own play button just plays; it no longer expands
            anything. */}
        <div className="cd-audio-row">
          <span className="audio-label1">Audio</span>
          {src && !loadingAudio ? (
            playerOpen ? (
              <button
                type="button"
                className="cd-listen-btn cd-listen-btn--close"
                onClick={closePlayer}
                title="Collapse the player and show the call details"
              >
                <FaChevronUp size={10} />
                <span>Hide transcript</span>
              </button>
            ) : (
              <button
                type="button"
                className="cd-listen-btn"
                onClick={() => openPlayer(true)}
                title="Open the player with the synchronised transcript"
              >
                <FaAlignLeft size={11} />
                <span>Listen with transcript</span>
              </button>
            )
          ) : null}
        </div>
        {playerOpen ? (
          <TranscriptPlayer
            src={src}
            transcript={transcriptState.transcript}
            mapping={transcriptState.mapping}
            transcriptStatus={
              transcriptState.status === "idle"
                ? "loading"
                : transcriptState.status
            }
            autoPlay={playerAutoPlayRef.current}
            initialTime={playbackPosRef.current}
            onProgress={(t) => {
              playbackPosRef.current = t;
            }}
            agentNames={agentNames}
          />
        ) : (
          <div className="audio-section-fixed">
            {loadingAudio ? (
              <span className="audio-status">Loading...</span>
            ) : src ? (
              // Coherent handoff in both directions: this bar starts where
              // the expanded player stopped, and everything it does — play,
              // seek — updates the shared position, so "Listen with
              // transcript" continues from here instead of from zero.
              <CustomAudioPlayer
                src={src}
                initialTime={playbackPosRef.current}
                onSeek={(t) => {
                  playbackPosRef.current = t;
                }}
                onProgress={(t) => {
                  playbackPosRef.current = t;
                }}
              />
            ) : (
              <span className="audio-status">
                {errorAudio || "No Audio Available"}
              </span>
            )}
          </div>
        )}

        <button
          type="button"
          className="cd-section-toggle"
          onClick={() => setInfoOpen((v) => !v)}
          aria-expanded={infoOpen}
        >
          <h3>Call Information</h3>
          {infoOpen ? (
            <FaChevronUp size={11} className="cd-chevron" />
          ) : (
            <FaChevronDown size={11} className="cd-chevron" />
          )}
        </button>

        {infoOpen && (
          <>
        <div className="frame-parent2">
          <div className="duration">Duration</div>
          <div className="duration-content">
            <div className="minute">
              {formatDuration(firstCallDetail.duration)}
            </div>
            <img className="schedule-icon" src={watch} alt="clock" />
          </div>
        </div>

        <div className="conversation-item">
          <span className="label">Inbound/Outbound Call</span>
          <span className="inbound">
            {capitalize(firstCallDetail.callType) || "---"}
          </span>
        </div>

        <div className="conversation-item">
          <span className="label">Call Urgency</span>
          <button
            className="button4"
            style={{
              backgroundColor:
                urgencyStyles[urgency?.toLowerCase()]?.bgColor || "gray",
              color: urgencyStyles[urgency?.toLowerCase()]?.color || "black",
            }}
          >
            <span
              className="circle"
              style={{
                backgroundColor: urgencyStyles[urgency?.toLowerCase()]?.color,
              }}
            ></span>
            <span className="text4">
              {urgencyStyles[urgency?.toLowerCase()]?.text || "---"}
            </span>
          </button>
        </div>
        {mnScore !== undefined && (
          <div className="conversation-item1">
            <span className="label">MN Score</span>
            <div className="rating-category">{mnScore}</div>
          </div>
        )}

        <div className="conversation-item1">
          <span className="label">Overall Quality of Conversation</span>
          <div className="rating-category">
            {(() => {
              const ratingVal = parseFloat(firstCallDetail.rating);
              if (!isNaN(ratingVal)) {
                // Ensure rating stays within 0-5 bounds
                const ratingOutOf5 = Math.min(5, Math.max(0, ratingVal));
                const fullStars = Math.floor(ratingOutOf5);
                const halfStars = ratingOutOf5 % 1 >= 0.5 ? 1 : 0;
                const emptyStars = Math.max(0, 5 - fullStars - halfStars);

                return (
                  <>
                    <span className="value">{ratingOutOf5.toFixed(1)}/5</span>
                    <div className="star-rating">
                      {[...Array(fullStars)].map((_, i) => (
                        <FaStar key={`full-${i}`} color="#ffc403" size={14} />
                      ))}
                      {halfStars === 1 && (
                        <FaStarHalfAlt color="#ffc403" size={14} />
                      )}
                      {[...Array(emptyStars)].map((_, i) => (
                        <FaRegStar
                          key={`empty-${i}`}
                          color="#ffc403"
                          size={14}
                        />
                      ))}
                    </div>
                  </>
                );
              }
              return <span className="value">---/5</span>;
            })()}
          </div>
        </div>
          </>
        )}
      </div>

      <CategoryLeadPopup
        isOpen={isCategoryLeadOpen}
        onClose={() => setIsCategoryLeadOpen(false)}
        onSave={handleCategoryLeadSave}
        callId={CallIdFetch?.CallId}
        primaryLabel="Primary Category Lead"
        primaryOptions={allCategoryOptions}
        primaryValue={primaryCategoryValue}
        onPrimaryChange={setPrimaryCategoryValue}
        secondaryLabel="Secondary Category Lead"
        secondaryOptions={allCategoryOptions}
        secondaryValues={secondaryCategoryValues}
        onSecondaryChange={setSecondaryCategoryValues}
      />

      <CallReviewSheetPopup
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        onSave={(data) => console.log("Saved:", data)}
        // optional: initialData={yourData}  — defaults to the dummy JSON
      />
    </div>
  );
};

export default ContactDetails;
